<!--  会员特权详情页面，如果是领取免费会员的tab点进来的话，会有领取的按钮； -->

<template>
  <div class="vip-privileges">
    <div class="vip-privileges-free" v-if="showFreeVipBtn">{{day}}天会员免费领</div>
    <div class="vip-privileges-title">
      <div class="back-btn" @click="goBack">返回</div>
      {{showFreeVipBtn?'您可以享受以下特权':'会员专属特权'}}
    </div>
    <div class="vip-privileges-items">
      <div class="vip-privileges-item" v-for="(item, index) in privileges" :key="item.id">
        <div class="vip-privileges-item-img-box">
          <img :src="item.img" alt>
        </div>
        <div class="vip-privileges-item-text">
          <div class="vip-privileges-item-name">{{item.name}}</div>
          <div class="vip-privileges-item-detail">{{item.detail}}</div>
        </div>
      </div>
    </div>
    <!--会员服务协议-->
    <div class="vip-agreement" v-if="showFreeVipBtn">
      <span @click="goAgreement">会员服务协议</span>
      <div class="line-left"></div>
      <div class="line-right"></div>
    </div>
    <!--获取免费会员按钮-->
    <div class="get-free-vip-btn-area" v-if="showFreeVipBtn"></div>
    <div class="get-free-vip-btn" @click="getFreeVipNow" v-if="showFreeVipBtn">立即领取</div>

    <!--请求失败的弹窗-->
    <Alert ref="alertTem"/>
  </div>
</template>

<script>
import service from "../utils/http";
import Alert from "../components/Alert.vue";
import LocalStorage from "../utils/localstorage";

export default {
  name: "vipPrivileges",
  components: {
    Alert
  },
  data() {
    return {
      privileges: [
        {
          img: require("../assets/1img.svg"),
          name: "语聊实时变声",
          id: 1,
          detail: "微信、QQ等APP线上语音通话，均可实时变声"
        },
        {
          img: require("../assets/2img.svg"),
          name: "游戏通话变声",
          id: 2,
          detail: "打游戏通话随性变声，交流更好玩"
        },
        {
          img: require("../assets/3img.svg"),
          name: "短语音变声",
          id: 3,
          detail: "微信、QQ等语音消息变声"
        },
        {
          img: require("../assets/4img.svg"),
          name: "直播变声",
          id: 4,
          detail: "主播全程说话变声"
        },
        {
          img: require("../assets/5img.svg"),
          name: "任选变声音效",
          id: 5,
          detail: "多款音效选择，会员全场免费用"
        },
        {
          img: require("../assets/6img.svg"),
          name: "免费升级",
          id: 6,
          detail: "更多音效，更多功能，会员免费升级"
        },
        {
          img: require("../assets/7img.svg"),
          name: "专属折扣",
          id: 7,
          detail: "参与会员专属优惠活动"
        },
        {
          img: require("../assets/8img.svg"),
          name: "专属客服",
          id: 8,
          detail: "为您使用过程中答疑解惑"
        }
      ],
      showFreeVipBtn: this.$route.query.showfreebtn ? true : false,
      day: this.$route.query.day ? this.$route.query.day : 0,
      commodityId: this.$route.query.commodityid
        ? this.$route.query.commodityid
        : 0
    };
  },
  methods: {
    getFreeVipNow: function() {
      console.log("获取免费会员");
      let self = this;
      let appkey = LocalStorage.getStr("appkey");
      service({
        method: "post",
        url: "voice_package/activationuserpackage",
        data: {
          appkey: appkey,
          commodity_id: self.commodityId,
          goods_type: 2
        }
      })
        .then(function(response) {
          console.log(response);
          if (response.data.code == 0) {
            self.$router.go(-1);
          }
        })
        .catch(function(error) {
          console.log(error);
          self.$refs.alertTem.showAlertFun();
        });
    },
    goAgreement: function() {
      this.$router.push({ name: "agreement" });
    },
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.vip-privileges {
  text-align: left;
  width: 100%;
  overflow: auto;
  .vip-privileges-free {
    height: 0.5rem;
    width: 100%;
    background: url("../assets/7DayFreeVipGetBg.svg");
    background-repeat: no-repeat;
    background-size: cover;
    line-height: 0.5rem;
    font-size: 0.26rem;
    color: #9a6424;
    text-align: center;
  }
  .vip-privileges-title {
    height: 0.7rem;
    line-height: 0.7rem;
    font-size: 0.22rem;
    color: #232220;
    padding: 0 0.3rem;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    .back-btn {
      height: 0.23rem;
      line-height: 0.23rem;
      width: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.2rem;
      position: absolute;
      left: 0.3rem;
      top: 0.23rem;
      text-align: left;
      background-image: url("../assets/back_000.svg");
      background-repeat: no-repeat;
      background-size: 0.13rem 0.23rem;
      background-position: top left;
    }
  }
  .vip-privileges-items {
    width: 100%;
    overflow: auto;
    padding-left: 0.3rem;
    box-sizing: border-box;
    .vip-privileges-item {
      height: 1.18rem;
      position: relative;
      .vip-privileges-item-img-box {
        height: 0.88rem;
        width: 0.88rem;
        border-radius: 0.44rem;
        position: absolute;
        left: 0;
        top: 0;
        img {
          height: 100%;
          width: 100%;
          border: none;
          float: left;
        }
      }
      .vip-privileges-item-text {
        width: 100%;
        padding-left: 1.06rem;
        box-sizing: border-box;
        height: 0.88rem;
        .vip-privileges-item-name {
          height: 0.44rem;
          line-height: 0.58rem;
          color: #232220;
          font-size: 0.22rem;
        }
        .vip-privileges-item-detail {
          height: 0.32rem;
          line-height: 0.32rem;
          width: 100%;
          font-size: 0.16rem;
          color: #65635e;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  /*******************会员服务协议********************/
  .vip-agreement {
    height: 0.45rem;
    line-height: 0.22rem;
    color: #e5cc96;
    text-align: center;
    position: relative;
    font-size: 0.16rem;
    text-decoration: underline;
    .line-left {
      height: 0.02rem;
      transform: scaleY(0.5);
      width: 1.78rem;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1),
        rgba(255, 196, 141, 1)
      );
      position: absolute;
      top: 0.1rem;
      left: 0.3rem;
    }
    .line-right {
      height: 0.02rem;
      transform: scaleY(0.5);
      width: 1.78rem;
      background: linear-gradient(
        90deg,
        rgba(255, 196, 141, 1),
        rgba(255, 255, 255, 1)
      );
      position: absolute;
      top: 0.1rem;
      right: 0.3rem;
    }
  }
  /******************获取免费会员按钮*******************/
  .get-free-vip-btn-area {
    width: 100%;
    height: 0.58rem;
    margin-bottom: 0.24rem;
  }
  .get-free-vip-btn {
    width: 4.8rem;
    height: 0.58rem;
    position: fixed;
    left: 50%;
    margin-left: -2.4rem;
    bottom: 0.24rem;
    text-align: center;
    border-radius: 0.08rem;
    background: linear-gradient(
      -90deg,
      rgba(240, 222, 172, 1),
      rgba(218, 185, 127, 1)
    );
    line-height: 0.58rem;
    font-size: 0.22rem;
    color: #232220;
    box-shadow: 0 0.14rem 0.11rem -0.06rem rgba(221, 184, 122, 0.5);
  }
}
</style>
